module.exports = __webpack_public_path__ + "static/media/page2-right.27a8ecfa.jpg";